import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";

export * from "./IRoute";

export {

    PrivateRoutes,
    PublicRoutes,
}